import { useState } from 'react';
import { truncate } from 'sdk';
import StarSVG from '~/assets/svg/icons/star';
import styles from '~/styles/pages/review-card.module.scss';
import COLORS from '~/lib/helpers/color-helper';

export default function AppReviewContent(props: { titles: string[]; reviews: string[]; authors?: string[] }) {
  const [isTruncated, setIsTruncated] = useState(Array(props.titles.length).fill(true));

  const toggleTruncate = (index: number) => {
    setIsTruncated((prevState) => prevState.map((item, idx) => (idx === index ? !item : item)));
  };

  const truncateText = (text: string, index: number) => {
    if (text.length > 100 && isTruncated[index]) {
      return truncate(text, 160);
    } else {
      return text;
    }
  };

  return (
    <div className={styles['review-card-div']}>
      {props.titles.map((title, idx) => {
        return (
          <div className={styles['review-card-container']}>
            <div
              className={
                isTruncated[idx] ? styles['review-card-title'] : `${styles['review-card-title']} ${styles['expanded']}`
              }
            >
              <>
                <div className={styles['review-stars']}>
                  {[...Array(5)].map((i, index) => (
                    <StarSVG strokeColor={COLORS.yellow} key={index} />
                  ))}
                </div>
                <div key={idx}>{title}</div>
              </>
            </div>
            <div className={styles['review-card-text']}>
              {' '}
              {isTruncated ? truncateText(props.reviews[idx], idx) : props.reviews[idx]}
            </div>
            {isTruncated[idx] ? (
              <div
                className={styles['click-text']}
                onClick={() => {
                  toggleTruncate(idx);
                }}
              >
                <div>{'Read more'}</div>
              </div>
            ) : (
              <div
                className={`${styles['click-text']} ${styles['expanded']}`}
                onClick={() => {
                  toggleTruncate(idx);
                }}
              >
                <div>{'Read less'}</div>
              </div>
            )}

            {props.authors ? (
              <>
                <div className={styles['review-card-author']}>- {props?.authors[idx]}</div>
              </>
            ) : (
              ''
            )}
          </div>
        );
      })}
    </div>
  );
}
